import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/utils/Stream';

import getUserInfo from "../../common/util/getUserInfo";
import InfoQueriesSuccessModal from "./InfoQueriesSuccessModal";

export default class ItemQueryModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.infoBaseData = this.attrs.infoBaseData;
    this.itemID = this.infoBaseData.id();
    this.itemSN = this.infoBaseData.sn();

    const currentUserData = app.session.user;

    if(currentUserData){
      let userInfo = getUserInfo(currentUserData.id());
      let option_lxdh_checked = userInfo.lxdh()===userInfo.lxdh_wx();

      this.option_zsxm = Stream(userInfo.zsxm());
      this.option_zsxm_title = Stream(userInfo.zsxm_title());
      this.option_lxdh = Stream(userInfo.lxdh());
      this.option_lxdh_checked = Stream(option_lxdh_checked?0:1);
      this.option_lxdh_wx_value = Stream(userInfo.lxdh_wx());
      this.option_lxdh_wx_value_disabled = Stream(option_lxdh_checked);
    }else{
      this.option_zsxm = Stream("");
      this.option_zsxm_title = Stream(0);
      this.option_lxdh = Stream("");
      this.option_lxdh_checked = Stream(0);
      this.option_lxdh_wx_value = Stream("");
      this.option_lxdh_wx_value_disabled = Stream(true);
    }
  }

  onModalReady(){
    const _this = this;
    $('input[type=radio][name=option_lxdh_checked]').on('change', function() {
      let value = parseInt($(this).val());
      _this.option_lxdh_checked(value);
      _this.option_lxdh_wx_value_disabled(value===0);
      _this.option_lxdh_wx_value(value===0?_this.option_lxdh():"");

      m.redraw();
    });

    $('input[type=radio][name=option_zsxm]').on('change', function() {
      _this.option_zsxm_title(parseInt($(this).val()));
    });
  }

  className() {
    return 'Modal--medium';
  }

  title() {
    return app.translator.trans('ziven-u2di.forum.title-query');
  }

  content() {
    return (
      <div className="Modal-body" style="padding-top: 0px;" oncreate={this.onModalReady.bind(this)}>
        <div className="u2diItemQueryContainier Form">
          <div style="padding-top: 20px;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.item-sn')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              {this.itemSN}
            </div>
          </div>

          <div style="padding-top: 12px;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zsxm')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <div className="u2diOptionsAdjustItem">
                <input required className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.option_zsxm} />
              </div>
              <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                <input className="u2diUserSubmitCategoryItemRadio" id="zsxm_title0" type="radio" name="option_zsxm" value="0" checked={this.option_zsxm_title()==0?"checked":""} /><label style="margin-left: 5px;" for="zsxm_title0">{app.translator.trans('ziven-u2di.forum.option-zsxm-0')}</label>
                <input className="u2diUserSubmitCategoryItemRadio" id="zsxm_title1" type="radio" name="option_zsxm" value="1" checked={this.option_zsxm_title()==1?"checked":""} /><label style="margin-left: 5px;" for="zsxm_title1">{app.translator.trans('ziven-u2di.forum.option-zsxm-1')}</label>
              </div>
            </div>
          </div>

          {this.option_zsxm()!=="" && (this.option_zsxm().length<2 || this.option_zsxm().length>4) && (
            <div className="u2diUserSubmitCategoryItems ">
              <div className="u2diUserSubmitCategoryItemName">
              </div>
              <div style="color:var(--alert-error-bg)" className="u2diUserSubmitCategoryItemOptions">
                真实姓名长度需要在2-4个字之间
              </div>
            </div>
          )}

          <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName" >
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-lxdh')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <div className="u2diOptionsAdjustItem">
                <input required className="FormControl u2diUserSubmitCategoryItemInput" type="text" maxlength="11" bidi={this.option_lxdh} />
              </div>
              <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                <input className="u2diUserSubmitCategoryItemRadio" id="lxdh_wx0" type="radio" name="option_lxdh_checked" value="0" checked={this.option_lxdh_checked()==0?"checked":""} /><label style="margin-left: 5px;" for="lxdh_wx0">{app.translator.trans('ziven-u2di.forum.option-lxdh-wx-0')}</label>
              </div>
              <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1" style="padding-top: 0px;">
                <input className="u2diUserSubmitCategoryItemRadio" id="lxdh_wx1" type="radio" name="option_lxdh_checked" value="1" checked={this.option_lxdh_checked()==1?"checked":""} /><label style="margin-left: 5px;" for="lxdh_wx1">{app.translator.trans('ziven-u2di.forum.option-lxdh-wx-1')}</label>
                <input maxlength="11" id="lxdh_wx_input" required style="margin-left: 15px;" className="FormControl u2diUserSubmitCategoryItemInput" type="text" disabled={this.option_lxdh_wx_value_disabled()} bidi={this.option_lxdh_wx_value} />
               </div>
            </div>
          </div>
          <div style="text-align: center;padding-top: 20px;">
            {Button.component({
                style:"min-width:66px;",
                disabled: this.loading,
                type: 'submit',
                className: 'Button Button--primary',
              },
              app.translator.trans('ziven-u2di.lib.submit')
            )}
            &nbsp;
            {Button.component({
                style:"min-width:66px;",
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();

    if((this.option_zsxm().length)<2 || (this.option_zsxm().length)>4){
      return;
    }
    
    this.loading = true;

    const submitData = {
      itemID:this.itemID,
      phone:this.option_lxdh(),
      xdxx:
        JSON.stringify({
          option_zsxm:this.option_zsxm(),
          option_zsxm_title:this.option_zsxm_title(),
          option_lxdh:this.option_lxdh(),
          option_lxdh_checked:this.option_lxdh_checked(),
          option_lxdh_wx_value:this.option_lxdh_wx_value(),
          option_lxdh_wx_value_disabled:this.option_lxdh_wx_value_disabled(),
        })
    };

    $(".Modal-close").hide();
    
    app.store
        .createRecord("u2diInfoQueries")
        .save(submitData)
        .then((result) => {
            app.modal.show(InfoQueriesSuccessModal);
          }
        )
        .catch((e) => {
          this.loading = false;
        });

  }
}